export default "__VITE_ASSET__f956ed00__"